import React from 'react';
import { useQuery } from 'react-query';
import { Grid, Divider, makeStyles, Typography } from '@material-ui/core';
import { round } from 'lodash';
import { useTranslation } from 'react-i18next';

import { getObjectiveKPIsByObjective } from '../../../api/objective/objectiveKPI.api';
import CreateKPI from './CreateKPI';
import ObjectiveKPIDetails from './ObjectiveKPIDetails';
import { calculateKPIProgress, calculateKPIProrate } from '../../../utils/objectives';
import { formatDate } from '../../../utils/dates';
import { OWNER_TYPES } from '../../../utils/const';
import KPIProgressIndicator from './KPIProgressIndicator';

const useStyles = makeStyles({
  kpiRoot: {
    color: '#666666',
    background: '#F4F4F4',
    padding: 16
  },
  title: {
    color: '#999999',
    fontSize: 12,
    marginBottom: 8,
    textZransform: 'uppercase'
  }
}, { name: 'ObjectiveKPIs' });

const ObjectiveKPIs = ({
  objective
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const query = useQuery(
    [ 'objectiveKPIs', objective ],
    async () => {
      const { data } = await getObjectiveKPIsByObjective({
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
      return data;
    }
  );

  const editable = objective.owner[0].type === OWNER_TYPES.EMPLOYEE;

  return (
    <div className={ classes.kpiRoot }>
      <Typography className={ classes.title }>{t('objective.kpi.title.list')}</Typography>
      {query.data?.map(kpi => {
        const progress = round(calculateKPIProgress(kpi), 2);
        const prorate = round(calculateKPIProrate(kpi), 2);

        return <React.Fragment key={ kpi.objectiveKPIId }>
          <Grid container direction='row'>
            <Grid container item xs={ 8 } sm={ 4 } alignItems='center'>{kpi.name}</Grid>
            <Grid container item xs={ 4 } sm={ 2 } alignItems='center'>
              {kpi.goalValue} {kpi.unit}
            </Grid>
            <Grid container item xs={ 5 } sm={ 3 }  alignItems='center'>
              {formatDate(new Date(kpi.deadline))}
            </Grid>
            <Grid item xs={ 5 } sm={ 2 }>
              <KPIProgressIndicator prorate={ prorate } progress={ progress } showValue={ false }/>
            </Grid>
            <Grid item xs={ 2 } sm={ 1 }>
              <ObjectiveKPIDetails
                kpi={ kpi }
                progress={ progress }
                prorate={ prorate }
                objective={ objective }
                onSubmitSuccess={ query.refetch }
                editable={ editable }
              />
            </Grid>
          </Grid>
          <Divider />
        </React.Fragment>;
      }
      )}
      {editable &&
        <CreateKPI objective={ objective } onSubmitSuccess={ query.refetch } />
      }
    </div>
  );
};

export default ObjectiveKPIs;